module.exports = __webpack_public_path__ + "img/bfee.5b7e59ef.png";